import {AfterViewInit, Component, OnInit} from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import {FormControl, Validators} from '@angular/forms';
import {ApiService} from '../api/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements AfterViewInit, OnInit {

  email = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [Validators.required, Validators.minLength(7)]);

  inProgres = false;


  mod = 0;

  constructor(
    private authService: AuthService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private router: Router,
    private cookieService: CookieService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  /*
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>{
      const email = this.cookieService.get('email');
      const password = this.cookieService.get('password');
      console.log('fired ' + email )
      this.tryLogin(email,password)
    });
  }*/

  ngAfterViewInit(): void {
    const email =     (this.activatedRoute.snapshot.paramMap.get("email"))
    const password =  (this.activatedRoute.snapshot.paramMap.get("password"))

    this.tryLogin(this.activatedRoute.snapshot.data.cookies.email, this.activatedRoute.snapshot.data.cookies.password )
    this.tryLogin(email, password)
    //console.log(email+" "+password)
  }


  ngOnInit() {
    window.scroll(0,0)
  }

  public tryLogin(email, password) {

    this.inProgres = true;
    this.api.logIn(email, password).subscribe((response) => {
      //console.log(email)
      if (response.result == true) {
        this.cookieService.delete('affiliate');
        if (!response.partner) {
          this.authService.doSignInUser(email + ':' +
            password, atob(email));

          const expiredDate = new Date();
          expiredDate.setDate( expiredDate.getDate() + 365 );
          this.cookieService.delete('email')
          this.cookieService.delete('password')
          this.cookieService.set( 'email',email, expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
          this.cookieService.set( 'password',password, expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');

          var path = window.location.pathname.replace("/login","")
          path = path.replace("/admin","")
          path = path.replace("/"+encodeURIComponent(encodeURIComponent(email)),"")
          path = path.replace("/"+encodeURIComponent(encodeURIComponent(password)),"")
          path = path.replace("/"+(encodeURIComponent(email)),"")
          path = path.replace("/"+(encodeURIComponent(password)),"")
          console.log(path)
          this.router.navigateByUrl('/admin'+ path)
        }else {
          this.authService.doSignInUser(email + ':' +
            password, atob(email));
          this.router.navigateByUrl('/partner_manager')
        }
      } else {
        this.router.navigate([window.location.pathname]);
      }
      this.inProgres = false;
    });
    setTimeout(() => this.inProgres=false,7000); // 2500 is millisecond
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, this.translateService.instant('login.snackbar-action-1'), config);
  }

  sendResetPassword() {
    if (this.email.valid && !this.inProgres) {
      this.inProgres = true;
      this.api.resetPassword(btoa(this.email.value)).subscribe(() => {
        this.inProgres = false;
        this.mod = 2;
      })
    }
  }

  doLogIn() {
    if (this.email.valid && this.password.valid && !this.inProgres) {
      this.inProgres = true;
      this.api.logIn(btoa(this.email.value), btoa(this.password.value)).subscribe((response) => {
        if (response.result == true) {
          this.cookieService.delete('affiliate');
          if (!response.partner) {
            this.authService.doSignInUser(btoa(this.email.value) + ':' +
              btoa(this.password.value), this.email.value);

            const expiredDate = new Date();
            expiredDate.setDate( expiredDate.getDate() + 365 );

            this.cookieService.set( 'email',btoa(this.email.value), expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
            this.cookieService.set( 'password',btoa(this.password.value), expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
            var path = window.location.pathname.replace("/login","")
            path = path.replace("/admin","")
            this.router.navigateByUrl('/admin'+ path)
          }else {
            this.authService.doSignInUser(btoa(this.email.value) + ':' +
              btoa(this.password.value), this.email.value);
            const expiredDate = new Date();
            expiredDate.setDate( expiredDate.getDate() + 365 );
            this.cookieService.set( 'email',btoa(this.email.value), expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
            this.cookieService.set( 'password',btoa(this.password.value),expiredDate, '/', 'assetstore.assetx.it', false, 'Lax');
            this.router.navigateByUrl('/partner_manager')
          }
        }else {
          if (!response.partner)
            this.openSnackBar(this.translateService.instant('login.snackbar-message-1'));
          else
            this.openSnackBar(this.translateService.instant('login.snackbar-message-2'));
          this.password.reset();
        }
        this.inProgres = false;
      });
      setTimeout(() => this.inProgres=false,7000); // 2500 is millisecond
    }
  }

  /*
  doLogIn(email, password) {
    this.inProgres = true;
    this.api.logIn(email, password).subscribe((response) => {
      if (response.result == true) {
        this.cookieService.delete('affiliate');
        if (!response.partner) {
          this.authService.doSignInUser(email + ':' +
            password, atob(email));

          const expiredDate = new Date();
          expiredDate.setDate( expiredDate.getDate() + 365 );

          this.cookieService.set( 'email',email, expiredDate);
          this.cookieService.set( 'password',password, expiredDate);
          var path = window.location.pathname.replace("/login","")
          path = path.replace("/admin","")
          this.router.navigateByUrl('/admin'+ path)
        }else {
          this.authService.doSignInUser(email + ':' +
            password, atob(email));
          const expiredDate = new Date();
          expiredDate.setDate( expiredDate.getDate() + 365 );
          this.cookieService.set( 'email',email, expiredDate);
          this.cookieService.set( 'password',password,expiredDate);
          this.router.navigateByUrl('/partner_manager')
        }
      }else {
        if (!response.partner)
          this.openSnackBar(this.translateService.instant('login.snackbar-message-1'));
        else
          this.openSnackBar(this.translateService.instant('login.snackbar-message-2'));
        this.password.reset();
      }
      this.inProgres = false;
    });
    setTimeout(() => this.inProgres=false,7000); // 2500 is millisecond
  }*/

  getEmailErrorMessage() {
    return this.email.hasError('required') ? this.translateService.instant('login.null-value-error'):
      this.email.hasError('email') ? this.translateService.instant('login.email-not-valid') :
        '';
  }

  getPassworErrorMessage() {
    return this.password.hasError('required') ? this.translateService.instant('login.null-value-error') :
      this.password.hasError('minlength') ? this.translateService.instant('login.password-not-valid') :
        '';
  }

}
